
@let bannerImageUri = ThemeService?.brandingSettings?.headerSettings?.bannerImageUri;
@if (bannerImageUri) {
	<img class="banner-image theme-header" [style.height.px]="ThemeService?.brandingSettings?.headerSettings?.bannerImageHeight" [src]="bannerImageUri" vbImageLoad>
	
}
